import {
  AVAILABLE_MODULES,
  MODULE_ROUTES,
  type TModuleCode
} from '@/shared/routes';

/** Модуль известен кабинету: для его кода есть раздел. */
export const isKnownModuleCode = (code: string): code is TModuleCode =>
  Object.prototype.hasOwnProperty.call(MODULE_ROUTES, code);

/**
 * Разделы сессии по кодам модулей от бэкенда — в его порядке, без неизвестных и
 * повторов. Модулей бэкенд не прислал (`undefined`/`null`) — открыты разделы, для
 * которых есть API (`AVAILABLE_MODULES`). Раздел без API, который бэкенд открыл,
 * показывается с пустым списком.
 */
export const toSessionModules = (codes?: string[] | null): TModuleCode[] =>
  codes
    ? [...new Set(codes.filter(isKnownModuleCode))]
    : [...AVAILABLE_MODULES];

/**
 * Стартовый раздел сотрудника — путь первого открытого модуля. `undefined`, если ни
 * одного раздела сотруднику не открыто.
 */
export const getFirstModuleRoute = (
  modules: TModuleCode[]
): string | undefined => {
  const [first] = modules;
  return first && MODULE_ROUTES[first];
};
